export default {
  placeholders: {
    delivery_zip_code: 'Code postal',
    delivery_city: 'Ville',
    delivery_street_number: 'Numéro de rue',
    delivery_street_name: 'Nom de rue',
    type_your_address: 'Saisissez votre adresse',
  },
  errors: {
    address_suggestions_unavailable:
      "Impossible de charger les suggestions d'adresse. Vous pouvez toujours saisir votre adresse ci-dessous.",
  },
  buttons: {
    retry: 'Réessayer',
  },
};
